import { makeStyles } from '@mui/styles';

const useScreenMessageStyles = makeStyles({
	root: {
		fontFamily: 'Montserrat',
	},
	rootFullHeight: {
		height: '100%',
	},
	rootFullWidth: {
		width: '100%',
	},
	title: {
		color: '#003C82',
		fontSize: '37px',
		fontWeight: 'bold',
		letterSpacing: 0,
		margin: 0,
		padding: 0,
		textAlign: 'center',
	},
	description: {
		color: '#00000099',
		fontSize: '21px',
		fontWeight: 500,
		margin: 0,
		padding: 0,
		textAlign: 'center',
	},
});

export default useScreenMessageStyles;
